import  { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PreviewItemCarrito from "../home/PreviewItemCarrito";
import GiftProduct from "@components/GiftProduct";
import axios from "@fetch/axios"
import { TokenContext } from "@context/TokenContext";
import { useTranslation } from "@hooks/useTranslation";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import { CartContext } from "@context/CardContext";

const Component = () => {
  const navigate = useNavigate();
  const [productos, setProductos] = useState([]);
  const [discount, setDiscount] = useState(null);
  const [subtotal, setSubtotal] = useState(null);
  const [total, setTotal] = useState(null);
  const { getToken,getVerified } = useContext(TokenContext);
  const {translate} = useTranslation();
  const { currency,lang } = useContext(LanguageCurrencyContext);
  const {  shipping, setTotalPay, setShipping } = useContext(CartContext);
  const [redward, setRedward] = useState(null);
  
  const fetchCarrito = async () => {

    if (localStorage.getItem('cartId') !== null) {

      try {

        const res = await axios.get('/cart/resume-order?currency='+currency+'&lang='+lang+'&id=' + localStorage.getItem('cartId') + '&verified=' + (getVerified() ? 1 : 0),
          {
            headers: { 'Authorization': 'Bearer ' + getToken() }
          }
        );
        if (res.data) {
          setProductos(res.data.cart_products)
          setRedward(res.data.reward)
          setDiscount(res.data.discount)
          setShipping(res.data.shipping)
          setSubtotal(res.data.subtotal)
          setTotal(res.data.total)
          setTotalPay(res.data.total);
        }


      } catch (error) {
        console.log('Error fetching address list', error);
      }

    }

  };

  useEffect(() => {

    fetchCarrito()

  }, [])

  return (
    <section className="CheckoutBox">
      <article>
        <div className="StepCheckout">
          <div className="Selected" onClick={() => navigate('/checkout-guest')} style={{ cursor: "pointer" }}></div>
          <div className="Selected" onClick={() => navigate('/checkout-envio')} style={{ cursor: "pointer" }}></div>
          <div className="Selected"></div>
          <div></div>
        </div>
        <div className="icon-Package" onClick={()=>navigate('/carrito')} style={{ cursor:"pointer" }}></div>
        <h5>{translate('summary.title')}</h5>
        <div className="ResumenPedido">
          <div>
            {productos.length > 0 && productos.map((producto, index) => (
              <PreviewItemCarrito 
              key={index} 
              producto={producto} 
              redirect={false}
              refetchCart={fetchCarrito}
               />
            ))}

          </div>

          {(redward && redward.has_gift) ? <GiftProduct 
            imageSrc={redward.gift_image ?? require("../../assets/images/gift-product.png")}
            title={redward.gift_name}
            details={redward.gift_description}
            plecaText={translate('summary.gift')}
          />:''}

          
          
          <div className="ResumenCheckout">
            <div>
              <span>Subtotal</span>
              <span>${subtotal}</span>
            </div>
            {/* <div>
              <span>Impuestos</span>
              <span>$00.00</span>
            </div> */}
            {discount &&
              <div>
                <span>{translate('shopping.discount')}</span>
                <span>${discount}</span>
              </div>
            }
            <div>
              <span>{translate('shopping.shipping')}</span>
              <span>${shipping}</span>
            </div>
            <div>
              <h5>Total:</h5>
              <h5>${total}</h5>
            </div>
          </div>
        </div>
        <div
          className="ButtonDarkMedium"
          onClick={() => navigate("/checkout-pago")}
        >
          {translate('checkout.continue')}
          <i className="icon-Check"></i>
        </div>
      </article>
    </section>
  );
};

export default Component;
